/**
 * DevExtreme (esm/__internal/scheduler/r1/utils/timeline_week.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { getValidCellDateForLocalTimeFormat } from "./base";
export const getDateForHeaderText = (index, date, _ref) => {
  let {
    startDayHour: startDayHour,
    startViewDate: startViewDate,
    cellCountInDay: cellCountInDay,
    interval: interval,
    viewOffset: viewOffset
  } = _ref;
  return getValidCellDateForLocalTimeFormat(date, {
    startViewDate: startViewDate,
    startDayHour: startDayHour,
    cellIndexShift: index % cellCountInDay * interval,
    viewOffset: viewOffset
  });
};